import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import classNames from "classnames";
import * as userSettingsActions from "../../actions/userSettings";

import styles from "./UserSettings.css";

class SocialSettings extends Component {
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this
      .props
      .userSettingsActions
      .typingUserSettings({
        [event.target.name]: event.target.value,
      });
  }

  handleSubmit() {
    this
      .props
      .userSettingsActions
      .submitUserSettings(this.props.userSettings.data.profileInfo);
  }

  render() {
    return (
      <div className={classNames(styles.infoWrapper, styles.marginTop20)}>
        <div className={styles.blueHeading}>
          SOCIAL MEDIA
        </div>

        <Row className={styles.marginTop20}>
          <Col lg="2" sm="12" xs="12" className={styles.muted}>LINKEDIN</Col>
          <Col lg="10" sm="12" xs="12">
            <input aria-label="LinkedIn" name="linkedin" onChange={this.handleChange} type="text" className={styles.bottomLineInputs} value={this.props.userSettings.data.profileInfo.linkedin} />
          </Col>
        </Row>

        <Row className={styles.marginTop20}>
          <Col lg="2" sm="12" xs="12" className={styles.muted}>FACEBOOK</Col>
          <Col lg="10" sm="12" xs="12">
            <input aria-label="Facebook" name="facebook" onChange={this.handleChange} type="text" className={styles.bottomLineInputs} value={this.props.userSettings.data.profileInfo.facebook} />
          </Col>
        </Row>

        <Row className={styles.marginTop20}>
          <Col lg="2" sm="12" xs="12" className={styles.muted}>TWITTER</Col>
          <Col lg="10" sm="12" xs="12">
            <input aria-label="Twitter" name="twitter" onChange={this.handleChange} type="text" className={styles.bottomLineInputs} value={this.props.userSettings.data.profileInfo.twitter} />
          </Col>
        </Row>

        <div className={styles.textCenter}>
          <button onClick={this.handleSubmit} type="button" className={classNames(styles.marginTop40, styles.blueButton1, styles.mobileBlock, styles.saveSocialButton)}>
            Save changes
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userSettings: state.userSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    userSettingsActions: bindActionCreators(userSettingsActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SocialSettings);



// WEBPACK FOOTER //
// ./src/users/components/UserSettings/SocialSettings.js